module.exports = __webpack_public_path__ + "img/fr-map-bg.65ab1aad.png";